import { Injectable, inject } from '@angular/core';
import { classes } from 'polytype';
import { type Observable, of } from 'rxjs';

import type { FoundationModelAdapter } from '@app/modules/assets/models/foundation-model.model';
import { FOUNDATION_MODEL_PATH } from '@app/shared/constants/api-route.config';
import { MODEL_INPUT_TYPE } from '@app/shared/constants/shared.constant';
import { WithArtifactService } from '@app/shared/services/mixins/artifact.service';
import { WithAuditService } from '@app/shared/services/mixins/audit.service';
import { WithExportableService } from '@app/shared/services/mixins/export.service';
import { WithJobService } from '@app/shared/services/mixins/job.service';
import { WithLineageService } from '@app/shared/services/mixins/lineage.service';
import { WithLogService } from '@app/shared/services/mixins/log.service';
import { WithCrudVersionService } from '@app/shared/services/mixins/version.service';
import { WithWorkflowableService } from '@app/shared/services/mixins/workflow.service';
import { RestService } from '@app/shared/services/rest.service';
import { type TestCodeEvent, TestCodeService } from '@app/shared/services/test-code.service';
import { ToastNotificationService } from '@app/shared/services/toast-notification.service';

@Injectable({
    providedIn: 'root',
})
export class FoundationModelService extends classes(
    WithCrudVersionService<FoundationModelAdapter>,
    WithAuditService,
    WithArtifactService,
    WithWorkflowableService,
    WithLogService,
    WithExportableService,
    WithLineageService,
    WithJobService,
) {
    protected endpoint = FOUNDATION_MODEL_PATH;

    protected readonly api = inject(RestService);
    protected readonly toast = inject(ToastNotificationService);
    private readonly testCodeService = inject(TestCodeService);
    /**
     * Model supports Python, API, Custom as definition input type
     * @returns list of supported definition input types
     */
    getInputTypes() {
        return of({
            result: [
                {
                    name: MODEL_INPUT_TYPE.API_BASED,
                    text: 'API Based',
                },
                {
                    name: MODEL_INPUT_TYPE.PYTHON_FUNCTION,
                    text: 'Python Function',
                },
            ],
        });
    }

    runDebugCode(request: { id: number; code: string }): Observable<TestCodeEvent> {
        return this.testCodeService.run(`${this.endpoint}${request.id}/debug_code`, request.code);
    }
}
